import { render, staticRenderFns } from "./OrbitCurrentRoundContent.vue?vue&type=template&id=d273ab68&scoped=true"
import script from "./OrbitCurrentRoundContent.vue?vue&type=script&lang=ts"
export * from "./OrbitCurrentRoundContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d273ab68",
  null
  
)

export default component.exports